import { takeLatest, call, put, select } from 'redux-saga/effects';
import {
  GET_DB_AZURE, GET_DB_AZURE_SUCCESS, GET_DB_AZURE_ERROR
} from './constant';

import { getAzureSQLDBApi, getAzurePostgreSQLDBApi, getAzureMySQLDBApi } from './api';

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */
function* getAzureDBList(action) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    let data;
    const { dbType } = action;

    switch (dbType) {
      case 'sql':
        data = yield call(getAzureSQLDBApi, action, provider);
        break;
      case 'postgresql':
        data = yield call(getAzurePostgreSQLDBApi, action, provider);
        break;
      case 'mysql':
        data = yield call(getAzureMySQLDBApi, action, provider);
        break;
      default:
        data = yield call(getAzureSQLDBApi, action, provider);
    }

    yield put({ type: GET_DB_AZURE_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_DB_AZURE_ERROR, error });
  }
}



/**
 * Get Login Saga
 */
export function* manageAzureDBSaga() {
  yield takeLatest(GET_DB_AZURE, getAzureDBList);

}
